import React from 'react';

import dayjs, { formatDateString } from '~libs/dayjs';

import { Column } from '~components/table-view-v3';

const MSO_RATE = 0.6;

const isSahLevel = (sahLevel: unknown) => !String(sahLevel).toLowerCase().includes('hcp');

const currencyFormatter = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const columnsFactory = (start_date?: string, end_date?: string) => {
  const dayCount = start_date && end_date ? dayjs(end_date).diff(dayjs(start_date), 'day') + 1 : 0;

  const columns: Column[] = [
    {
      id: 'sah_level',
      header: 'SAH Level',
      type: 'text',
      classNames: {
        header: 'cell-align-left',
        column: 'cell-align-left',
      },
    },
    {
      id: 'annual_amount',
      header: 'Year Funds',
      type: 'currency',
      style: { width: '17%' },
      classNames: {
        header: 'cell-align-center',
        column: 'cell-align-center',
      },
      deriveValue: (row) => row.daily_amount * 365,
    },
    {
      id: 'amount_for_duration',
      header: `${formatDateString(start_date)} - ${formatDateString(end_date)}`,
      type: 'currency',
      style: { width: '19%' },
      classNames: {
        header: 'cell-align-center',
        column: 'cell-align-center',
      },
      deriveValue: (row) => row.daily_amount * dayCount,
    },
    {
      id: 'mso_amount',
      header: 'MSO 60%',
      type: 'currency',
      style: { width: '21%', whiteSpace: 'normal' },
      classNames: {
        header: 'cell-align-center',
        column: 'cell-align-center',
      },
      deriveValue: (row) => (isSahLevel(row.sah_level) ? row.daily_amount * dayCount * MSO_RATE : null),
      renderReadOnly: (value: number | null) => {
        if (value === null) {
          return React.createElement('div', { className: 'cell readonly cell-align-center' }, '-');
        }
        return React.createElement(
          'div',
          { className: 'cell readonly cell-align-center' },
          currencyFormatter.format(value),
        );
      },
    },
  ];

  return columns;
};

export default columnsFactory;
